/**
 * Перенос `lib/src/utils/lorem_ipsum.dart` — значения один в один.
 *
 * Это заглушки для скелетонов и превью карточек, пока данные не пришли.
 */

/**
 * В Dart это был многострочный литерал `'''…'''`: первый перевод строки
 * после кавычек отбрасывается, пустая строка в середине остаётся.
 */
const DEFAULT_PARAGRAPH = `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.

The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`;

export const LoremIpsum = {
  defaultTitle: 'Where does it come from?',

  defaultWord: 'Loading',

  /** Опечатка в имени — из Dart-исходника, имена полей сохранены как есть. */
  defualtDate: '23 Апреля, 2023',

  defaultPrice: '20 000 UZS',

  defaultParagraph: DEFAULT_PARAGRAPH,

  /** `defaultParagraph` четыре раза подряд, без разделителя. */
  bigParagraph:
    DEFAULT_PARAGRAPH + DEFAULT_PARAGRAPH + DEFAULT_PARAGRAPH + DEFAULT_PARAGRAPH,
} as const;
